import { toItems } from './previews';
import { DropzoneValue } from '../types';

/**
 * Как поле хранит картинки.
 *
 * Почти везде значение — просто список, но не везде: обложка организатора
 * держит объект `{ img, background }`, потому что вместе с логотипом сохраняется
 * цвет подложки под ним.
 *
 * Раньше такое поле подменяло у дропзоны `onDrop` — и тем самым выключало у себя
 * всю обработку: сжатие, отказы, объяснения. Приходилось следить, чтобы хук
 * вызывал чужой обработчик уже готовыми файлами. Адаптер разделяет это честно:
 * дропзона занимается картинками, поле — формой своего значения.
 */
export interface DropzoneValueAdapter {
  /** Достать картинки из значения поля. */
  read(value: unknown): DropzoneValue[];
  /** Положить изменившийся список обратно, сохранив остальное значение. */
  write(value: unknown, items: DropzoneValue[]): unknown;
}

/** Значение поля — список картинок. Так устроены все поля, кроме обложки. */
export const listValueAdapter: DropzoneValueAdapter = {
  read: toItems,
  write: (_value, items) => items,
};
